module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/open/17f3bf93d124c2306c49885e2dc31fb6.png";